import { Box, Text, styled, Tabs, Tab } from '@/theme/index';

export const FooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  paddingBottom: theme.spacing(3),
  display: 'flex',
  justifyContent: 'center',
}));

export const FooterSecondaryContainer = styled(Box)(({ theme }) => ({
  width: 800,
  padding: `0 ${theme.spacing(2)}`,
}));

export const FooterHeader = styled(Text)(({ theme }) => ({
  margin: `${theme.spacing(2)} 0`,
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    fontSize: theme.typography.fontSize * 3,
  },
}));

interface FooterTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

export const FooterTabs = styled((props: FooterTabsProps) => (
  <Tabs {...props} variant="fullWidth" centered />
))({
  '& .MuiTabs-flexContainer': {
    flexWrap: 'wrap',
  },

  '& .MuiTabs-indicator': {
    display: 'none',
  },
});

interface FooterTabProps {
  label: string;
  key: string;
  onClick: (event: React.SyntheticEvent) => void;
}

export const FooterTab = styled((props: FooterTabProps) => (
  <Tab {...props} disableRipple />
))(({ theme }) => ({
  color: 'text.primary',

  '&.Mui-selected': {
    borderBottom: `2px solid ${theme.palette.primary.main}`,
  },
}));
